/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-order.reducer';

export const ParamedicOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicOrderEntity = useAppSelector(state => state.paramedicOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicOrder.detail.title">ParamedicOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.timestampEntry}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.patientType}</dd>
          <dt>
            <span id="visitId">
              <Translate contentKey="tinyMedicRestApp.paramedicOrder.visitId">Visit Id</Translate>
            </span>
          </dt>
          <dd>{paramedicOrderEntity.visitId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.prescription">Prescription</Translate>
          </dt>
          <dd>{paramedicOrderEntity.prescription ? paramedicOrderEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.labPrescription">Lab Prescription</Translate>
          </dt>
          <dd>{paramedicOrderEntity.labPrescription ? paramedicOrderEntity.labPrescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.radiologyStudy">Radiology Study</Translate>
          </dt>
          <dd>{paramedicOrderEntity.radiologyStudy ? paramedicOrderEntity.radiologyStudy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.paramedic">Paramedic</Translate>
          </dt>
          <dd>{paramedicOrderEntity.paramedic ? paramedicOrderEntity.paramedic.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.patient">Patient</Translate>
          </dt>
          <dd>{paramedicOrderEntity.patient ? paramedicOrderEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-order/${paramedicOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicOrderDetail;
